var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8984 5.00098H7.22656C5.99687 5.00098 5 5.99784 5 7.22754V15.8994C5 17.1291 5.99687 18.126 7.22656 18.126H15.8984C17.1281 18.126 18.125 17.1291 18.125 15.8994V7.22754C18.125 5.99784 17.1281 5.00098 15.8984 5.00098Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9805 5.00098L15 4.06348C14.9983 3.48382 14.7674 2.92838 14.3575 2.5185C13.9476 2.10862 13.3922 1.87763 12.8125 1.87598H4.375C3.71256 1.87793 3.07781 2.14196 2.6094 2.61037C2.14098 3.07879 1.87696 3.71354 1.875 4.37598V12.8135C1.87665 13.3931 2.10765 13.9486 2.51753 14.3584C2.9274 14.7683 3.48285 14.9993 4.0625 15.001H5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.25bc4ef8b53089baacaefaf50fbcb53e.svg";
export { ForwardRef as ReactComponent };